<template>
    <div class="container">
        <div>
            <h3>Trips</h3>
        </div>

        <template v-if="trips.error">
            <feedback :error="trips.error"></feedback>
        </template>
        <template v-else>
            <trip_table :trips="trips.trips"></trip_table>
        </template>
    </div>
</template>

<script>
    import trip_table from "./trip_table";
    import {mapState} from "vuex";
    import Feedback from "../commons/feedback";

    export default {
        name: "trips",
        components: {Feedback, trip_table},
        computed: {
            ...mapState({
                trips: state => state.trips,
            }),
        }
    }
</script>

<style scoped>

</style>
